import { Build, Component, Element, h, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'mama-sticky-header',
})
export class MamaStickyHeader {
  @Element() el!: HTMLElement;
  @State() show = true;

  lastScrollTop = 0;
  delta = 25;
  navbarHeight: number;

  async componentDidLoad() {
    if (navigator.userAgent.match(/VisualRegressionTestingBot/i) || !Build.isBrowser) {
      return;
    }
    this.navbarHeight = this.el.clientHeight;
  }

  @Listen('scroll', { target: 'document' })
  scrollListener() {
    this.setHeaderVisibility();
  }

  setHeaderVisibility() {
    const scrollTop = window.scrollY;

    if (Math.abs(this.lastScrollTop - scrollTop) <= this.delta) {
      return;
    }

    this.show = !(scrollTop > this.lastScrollTop && scrollTop > this.navbarHeight);
    this.lastScrollTop = scrollTop;
  }

  render() {
    return (
      <Host class={{ show: this.show }}>
        <slot />
      </Host>
    );
  }
}
